export default __webpack_public_path__ + "92ff522cc79831515d944fc07e178b34.svg";